var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ClinicPage',{attrs:{"clinic_id":_vm.clinic_id,"current_user":_vm.current_user,"user_invites":_vm.user_invites,"route_subpage":_vm.subpage}})
}
var staticRenderFns = []

export { render, staticRenderFns }